import { useState } from 'react';
import { jwtDecode } from 'jwt-decode';

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken?.token
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    localStorage.setItem('token', JSON.stringify(userToken));
    setToken(userToken.token);
    let tokenInfo = jwtDecode(userToken.token);
        let tokenObj = JSON.parse(tokenInfo.token);
        let userStatus = tokenObj['status'];
        let userId = tokenObj['userId'];
        let userType = tokenObj['userType'];
        localStorage.setItem('userId', userId);
        localStorage.setItem('userType', userType);
        localStorage.setItem('userStatus', userStatus);
        localStorage.setItem('jwt', userToken.token);
  };

  return {
    setToken: saveToken,
    token
  }
}